import CalendarIcon from './calendar.png';
import Search from './search-blue.png';
import PaperclipIcon from './paperclip.png';
import UserIcon from './user.png';
import ArrowLeft from './arrow-left.png';
import LockIcon from './lock.png';
import PasswordInactive from './password-inactive.png';
import PasswordActive from './password-active.png';
import NotificationIcon from './notifications.png';
import LogoutIcon from './logout.png';
import ProfileIcon from './profile.png';
import DownloadIcon from './download.png';
import EditIcon from './edit.png';
import EditIconRed from './edit-red.png';
import AddIcon from './add.png';
import SearchIcon from './search.png';
import TrashIcon from './trash.png';
import ArrowUp from './arrow-up.png';
import ArrowBottom from './arrow-bottom.png';
import ViewIcon from './view.png';
import HashIcon from './hash.png';
import DownloadTableIcon from './download2.png';
import AddWhiteIcon from './add-white.png';
import EditIconWhite from './edit-white.png';
import ViewProviderIcon from './view-provider.png';
import LocationIcon from './location.png';
import MailIcon from './mail.png';
import PhoneIcon from './phone.png';
import TimeIcon from './time.png';
import TimeRedIcon from './time-red.png';
import PhoneRedIcon from './phone-red.png';
import MailRedIcon from './mail-red.png';
import EditCircleRed from './edit-circle-red.png';
import Switch from './switch.png';
import SwitchGreen from './switch-green.png';
import AddCircleRed from './add-circle-red.png';
import ViewUserIcon from './view-user.png';
import ArrowBottomBlack from './arrow-bottom-black.png';
import ArrowUpBlack from './arrow-up-black.png';
import CalendarWhite from './calendar-white.png';
import CommentsIcon from './comments.png';
import CommentsRedIcon from './comments-red.png';
import ShapeIcon from './shape.png';
import ColorIcon from './color.png';
import RotationIcon from './rotation.png';
import DeleteIcon from './delete.png';
import CheckRedIcon from './check-red.png';
import TimeCircleRed from './time-circle-red.png';
import CircleYellow from './circle-yellow.png';
import CircleYellowBell from './circle-yellow-bell.png';
import CircleGreen from './circle-green.png';
import CalendarRed from './calendar-red.png';
import CloseIcon from './close.png';
import HomeIcon from './home.png';
import CheckGreenIcon from './check-green.png';
import CanceledIcon from './canceled.png';
import MenuOpenIcon from './menu-open.png';
import CleanIcon from './clean.png';
import TrashWhiteIcon from './trash-white.png';
import CheckWhiteIcon from './check-white.png';
import ConfirmIcon from './confirm.png';
import StarIcon from './star.png';
import ArrowLeftBlack from './arrow-left-black.png';
import ArrowRightBlack from './arrow-right-black.png';
import PriceIcon from './price.png';
import GoogleMapsIcon from './google-maps.png';
import PrintIcon from './print.png';
import OperatorsIcon from './operators.png';
import QuoteIcon from './quote.png';
import ChangeStatusIcon from './change-status.png';
import CloseWhiteIcon from './close-white.png';
import UploadIcon from './upload.png';
import ArrowLeftWhite from './arrow-left-white.png';
import TicketIcon from './ticket.png';
import IncomeIcon from './income.png';
import ReturnsIcon from './returns.png';
import ExistenceIcon from './existence.png';
import IncomeWhiteIcon from './income-white.png';
import ReturnsWhiteIcon from './returns-white.png';
import ExistenceWhiteIcon from './existence-white.png';
import WhatsappIcon from './whatsapp.png';
import LocationWhiteIcon from './location-white.png';
import PhoneWhiteIcon from './phone-white.png';
import MailWhiteIcon from './mail-white.png';
import InstagramWhiteIcon from './instagram-white.png';
import InstagramYellowIcon from './instagram-yellow.png';
import CartWhiteIcon from './cart-white.png';
import CategoriesIcon from './categories.png';
import SearchWhiteIcon from './search-white.png';
import BtnPressIcon from './btn-press.png';
import BtnUrgentIcon from './btn-urgent.png';
import BtnSpecialIcon from './btn-special.png';
import WhatsappWhiteIcon from './whatsapp-white.png';
import MoneyIcon from './money.png';
import CopyIcon from './copy.png';
import ExcelIcon from './excel.png';
import SettingsIcon from './settings.png';
import SendEmailIcon from './send-email.png';
import SettingIcon from './setting.png';
import WhatsappSurveyIcon from './whatsapp-survey.png';
import InstagramSurveyIcon from './instagram-survey.png';
import EmailIcon from './email.png';
import Survey1Icon from './survey1.png';
import Survey2Icon from './survey2.png';
import Survey3Icon from './survey3.png';
import Survey4Icon from './survey4.png';
import Survey5Icon from './survey5.png';
import SurveyIcon from './survey.png';
import Survey6Icon from './survey6.png';
import PinIcon from './pin.png';
import RemoveIcon from './remove.png';
import PinSmallIcon from './pin-small.png';
import AlertIcon from './alert.png';
import ClockIcon from './clock.png';
import WhatsappBlueIcon from './whatsapp-blue.png';
import InstagramBlueIcon from './instagram-blue.png'; 
import CameraIcon from './camera.png';
import WebIcon from './web.png';

// Menu
import MenuModerators from './menu/moderators.png';
import MenuServices from './menu/services.png';
import MenuOperators from './menu/operators.png';
import MenuExchange from './menu/exchange.png';
import MenuQuotes from './menu/quotes.png';
import MenuClients from './menu/clients.png';
import MenuBankAccounts from './menu/bank-accounts.png';
import MenuClientHome from './menu/client-home.png';
import MenuClientProfile from './menu/client-profile.png';
import MenuClientQuotes from './menu/client-quotes.png';
import MenuClientPoints from './menu/client-points.png';
import MenuDiscount from './menu/discount.png';
import MenuShop from './menu/shop.png';
import MenuPriceMeter from './menu/price-meter.png';
import MenuPayment from './menu/payment.png';
import MenuAccessories from './menu/accessories.png';
import MenuJobApplications from './menu/job-applications.png';
import MenuReports from './menu/report.png';
import MenuPlanning from './menu/planning.png';
import MenuMyConnects from './menu/menu-my-connects.png';
import MenuConnect from './menu/menu-connect.png';
import MenuPlaces from './menu/menu-places.png';
import MenuJourneys from './menu/menu-journeys.png';
import MenuQuoteTypes from './menu/quote-types.png';

const Menu = {
	MenuOperators,
	MenuModerators,
	MenuServices,
	MenuExchange,
	MenuQuotes,
	MenuClients,
	MenuClientHome,
	MenuClientProfile,
	MenuClientQuotes,
	MenuBankAccounts,
	MenuDiscount,
	MenuShop,
	MenuPriceMeter,
	MenuPayment,
	MenuAccessories,
	MenuReports,
	MenuJobApplications,
	MenuClientPoints,
	MenuPlanning,
	MenuMyConnects,
	MenuConnect,
	MenuPlaces,
	MenuJourneys,
	MenuQuoteTypes
}

export {
	CalendarIcon,
	Search,
	ArrowLeft,
	PaperclipIcon,
	UserIcon,
	LockIcon,
	PasswordInactive,
	PasswordActive,
	Menu,
	NotificationIcon,
	LogoutIcon,
	ProfileIcon,
	DownloadIcon,
	EditIcon,
	EditIconRed,
	AddIcon,
	SearchIcon,
	TrashIcon,
	ArrowUp,
	ArrowBottom,
	ViewIcon,
	HashIcon,
	DownloadTableIcon,
	AddWhiteIcon,
	EditIconWhite,
	ViewProviderIcon,
	PhoneIcon,
	MailIcon,
	LocationIcon,
	TimeIcon,
	TimeRedIcon,
	PhoneRedIcon,
	MailRedIcon,
	EditCircleRed,
	Switch,
	SwitchGreen,
	AddCircleRed,
	ViewUserIcon,
	ArrowBottomBlack,
	ArrowUpBlack,
	CalendarWhite,
	CommentsIcon,
	CommentsRedIcon,
	ShapeIcon,
	DeleteIcon,
	RotationIcon,
	ColorIcon,
	CheckRedIcon,
	TimeCircleRed,
	CircleYellow,
	CircleYellowBell,
	CircleGreen,
	CalendarRed,
	CloseIcon,
	HomeIcon,
	CheckGreenIcon,
	CanceledIcon,
	MenuOpenIcon,
	CleanIcon,
	TrashWhiteIcon,
	CheckWhiteIcon,
	ConfirmIcon,
	StarIcon,
	ArrowLeftBlack,
	ArrowRightBlack,
	PriceIcon,
	GoogleMapsIcon,
	OperatorsIcon,
	PrintIcon,
	QuoteIcon,
	CloseWhiteIcon,
	ChangeStatusIcon,
	UploadIcon,
	ArrowLeftWhite,
	TicketIcon,
	IncomeIcon,
	ReturnsIcon,
	ExistenceIcon,
	IncomeWhiteIcon,
	ReturnsWhiteIcon,
	ExistenceWhiteIcon,
	WhatsappIcon,
	LocationWhiteIcon,
	PhoneWhiteIcon,
	MailWhiteIcon,
	InstagramWhiteIcon,
	InstagramYellowIcon,
	CartWhiteIcon,
	CategoriesIcon,
	SearchWhiteIcon,
	BtnPressIcon,
	BtnUrgentIcon,
	BtnSpecialIcon,
	MoneyIcon,
	WhatsappWhiteIcon,
	CopyIcon,
	ExcelIcon,
	SettingsIcon,
	SendEmailIcon,
	SettingIcon,
	InstagramSurveyIcon,
	WhatsappSurveyIcon,
	EmailIcon,
	Survey1Icon,
	Survey2Icon,
	Survey3Icon,
	Survey4Icon,
	Survey5Icon,
	SurveyIcon,
	Survey6Icon,
	PinIcon,
	RemoveIcon,
	PinSmallIcon,
	AlertIcon,
	ClockIcon,
	WhatsappBlueIcon,
	InstagramBlueIcon,
	CameraIcon,
	WebIcon
}